module.exports = __webpack_public_path__ + "assets/c387a3ef631b63cea029ff655e2c5bc0.png";